import { useTranslation } from 'react-i18next'
import { dirOf, isLocale, type Locale } from './locale'

/** The current locale and direction, re-rendering on change. */
export function useLocale(): { locale: Locale; dir: 'rtl' | 'ltr'; isRtl: boolean } {
  const { i18n } = useTranslation()
  const locale: Locale = isLocale(i18n.language) ? i18n.language : 'ar'
  const dir = dirOf(locale)
  return { locale, dir, isRtl: dir === 'rtl' }
}
